import React from 'react';

const SimpleNavbar = () => {
  return (
    <nav className="bg-black p-1">
        <h1 className="text-white text-center text-xl font-bold">بسم الله الرحمن الرحيم</h1>
        <div className="flex gap-4">
          
        </div>
      
    </nav>
  );
};

export default SimpleNavbar;
